export default __webpack_public_path__ + "static/media/m_1.828a629a.jpg";